import helpers from './helpers';

const rating = {
  /**
   * @param {object} data - Driver Rating
   * @param {string} formType - Form Type
   */
  create(data, formType) {
    return helpers.request(`ratings/${formType}`, helpers.requestOptions('POST', data));
  },
  /**
   * @param {string} formType - Form Type
   */
  options(formType) {
    return helpers.request(`ratings/${formType}`, helpers.requestOptions('OPTIONS'));
  },
};

export default rating;
